app.controller("ProductPriceController", [
  "$http",
  "$scope",
  "Config",
  function ($http, $scope, Config) {
    $scope.no_of_hire_days = 1;
    $scope.max_hire_days = 30;
    $scope.hire_price_reduction = 1.0;
    $scope.hire_days_reduction_array = [];
    $scope.no_of_hire_days_str = "1 day";
    $scope.init = function () {
      $scope.getHireDaysPriceReduction();
    };

    $scope.getHireDaysPriceReduction = function () {
      query_string = '?brand='+Config.brand_key+'&max-hire-days='+$scope.max_hire_days;
      $http({
        method: "GET",
        url: Config.api_url + "get-price-reductions" + query_string,
        headers: {
          authorization: Config.api_key,
        },
      }).then(function (response) {
        if ((response.data.status = "success")) {
          $scope.hire_days_reduction_array =
            response.data.hire_day_price_reductions;
        }
      });
    };

    $scope.changeNoOfHireDays = function (no_of_hire_days) {
      if (no_of_hire_days > 1) {
        $scope.no_of_hire_days_str = no_of_hire_days + " days";
      } else {
        $scope.no_of_hire_days_str = "1 day";
      }
      $scope.no_of_hire_days = no_of_hire_days;
      var new_hire_price_reduction_obj = undefined;
      var counter = 0;
      while (true) {
        const element = $scope.hire_days_reduction_array[counter];
        if (element.number_of_days == parseInt($scope.no_of_hire_days)) {
          new_hire_price_reduction_obj = element;
          break;
        }
        counter += 1;
        if (counter >= $scope.hire_days_reduction_array.length) {
          break;
        }
      }
      // for (
      //   let index = 0;
      //   index < $scope.hire_days_reduction_array.length;
      //   index++
      // ) {
      //   const element = $scope.hire_days_reduction_array[index];
      //   if (element.number_of_days === parseInt($scope.no_of_hire_days)) {
      //     new_hire_price_reduction_obj = element;
      //   }
      // }
      // $scope.hire_days_reduction_array.forEach((element) => {
      // if (element.number_of_days === parseInt($scope.no_of_hire_days)) {
      //   new_hire_price_reduction_obj = element;
      // }
      // });
      if (new_hire_price_reduction_obj !== undefined) {
        $scope.hire_price_reduction = parseFloat(
          new_hire_price_reduction_obj.price_reduction
        );
      }
    };
  },
]);
